'use client'

import { APP_VERSION } from '@/lib/version'

interface AppVersionDisplayProps {
  className?: string
}

const AppVersionDisplay = ({ className = '' }: AppVersionDisplayProps) => {
  return <span className={`text-b14 text-white opacity-50 ${className}`}>v{APP_VERSION ?? 'unknown'}</span>
}

export default AppVersionDisplay
